import { EditorContent } from "@tiptap/react";
import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";
import { useEffect } from "react";
import type { ClassNameProps } from "../../types";
import type { TextareaProps } from "./mentions";
import { useTiptap } from "./tiptap";

/** Props Interface */
export type TiptapVariantProps = VariantProps<typeof display>;

interface TiptapDisplayProps extends TextareaProps, TiptapVariantProps, ClassNameProps {
	json: string;
}

export function TiptapDisplay({
	members,
	projects,
	mentionRenderers,
	videoRenderer,
	imageRenderer,
	json,
	lineClamp,
	className,
}: TiptapDisplayProps) {
	/** Classes */
	const classes = display({ lineClamp });

	/** Tiptap */
	const { editor, handleOnGenerateContent } = useTiptap({
		isReadOnly: true,
		members,
		mentionRenderers,
		videoRenderer,
		imageRenderer,
		onChange: () => {},
		projects,
		value: json,
	});

	/** Effects */
	useEffect(() => {
		const content = handleOnGenerateContent(json);
		editor?.commands.setContent(content, {});
	}, [json]);

	return (
		<EditorContent
			editor={editor}
			className={clsx("tiptap-display", classes, className)}
		/>
	);
}

const display = cva([], {
	variants: {
		lineClamp: {
			none: "",
			1: "line-clamp-1",
			2: "line-clamp-2",
			3: "line-clamp-3",
			4: "line-clamp-4",
			5: "line-clamp-5",
			6: "line-clamp-6",
			7: "line-clamp-7",
			8: "line-clamp-8",
			9: "line-clamp-9",
			10: "line-clamp-10",
		},
	},
	defaultVariants: {
		lineClamp: "none",
	},
});
